"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const ProjectResponseResource_1 = __importDefault(require("../../ProjectResponseResource"));
const Resource_1 = __importDefault(require("../../../Resource"));
const ContributorResponseResource_1 = __importDefault(require("../Contributor/ContributorResponseResource"));
class ProjectTeamResponseResource extends Resource_1.default {
}
exports.default = ProjectTeamResponseResource;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProjectTeamResponseResource.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => ProjectResponseResource_1.default),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", ProjectResponseResource_1.default)
], ProjectTeamResponseResource.prototype, "project", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => ContributorResponseResource_1.default),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProjectTeamResponseResource.prototype, "projectLeader", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProjectTeamResponseResource.prototype, "createdAt", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProjectTeamResponseResource.prototype, "updatedAt", void 0);
